:host {
  @include cms-components-host-defaults;
  width: 100%;
  max-width: var(--cms-container-max-width);
  margin: 0 auto var(--cms-components-mb);

  a {
    @include cms-anchor-base-font;
  }
}

.table-container-inner {
  @include cms-default-grid-container;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

table {
  grid-area: var(--cms-default-grid-area);
  border-collapse: collapse;
  border: var(--cms-border-size-xs) solid
    var(--cms-semanticColors-base-weak-border);
  box-sizing: border-box;
  color: var(--cms-theme-text-color);
  overflow-wrap: break-word;
  word-wrap: break-word;

  th,
  td {
    text-align: left;
    padding: 0.5rem 1rem;

    &:focus {
      outline-color: var(--cms-semanticColors-container-strong-background);
      outline-width: 4px;
      outline-style: solid;
      outline-offset: -4px;
    }

    &.text-top {
      vertical-align: top;
    }

    &.text-middle {
      vertical-align: middle;
    }

    &.text-bottom {
      vertical-align: bottom;
    }

    &.text-left {
      text-align: left;
    }

    &.text-center {
      text-align: center;
    }

    &.text-right {
      text-align: right;
    }
  }

  th {
    font-family: var(--cms-brandfont2);
    font-weight: var(--cms-heading-base-font-weight);
  }

  tr {
    border: var(--cms-border-size-xs) solid
      var(--cms-semanticColors-base-weak-border);
  }

  /* Backgrounds */
  tr:not(:hover) {
    td,
    th {
      background-color: var(--cms-theme-table-background-color);
    }
  }

  tr:hover td,
  th {
    background-color: var(--cms-theme-medium-hover);
  }

  thead tr:not(:hover) th {
    background-color: var(--cms-theme-table-background-color-highlight);
  }
}

.top-left {
  th,
  td {
    border-right: var(--cms-border-size-xs) solid
      var(--cms-semanticColors-base-weak-border);
  }
}

.left:not(.striped) {
  th {
    border-right: var(--cms-border-size-xs) solid
      var(--cms-semanticColors-base-weak-border);
  }
}

.striped {
  &.with-header {
    tr:nth-child(2n):not(:hover) td,
    tr:nth-child(2n):not(:hover) th {
      background-color: var(--cms-theme-table-background-color-highlight);
    }
  }

  &:not(.with-header) {
    tr:nth-child(2n + 1):not(:hover) td,
    tr:nth-child(2n + 1):not(:hover) th {
      background-color: var(--cms-theme-table-background-color-highlight);
    }
  }

  tbody,
  thead,
  tr {
    border: none;
  }
}

.default {
  &.top-left,
  &.left {
    tr:not(:hover) {
      th {
        background-color: var(--cms-theme-table-background-color-highlight);
      }
    }
  }
}

@include media-width($breakpoint-sm) {
  table.two-thirds {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}
